document.addEventListener("DOMContentLoaded", () => {
    const $scrollBtn = document.querySelectorAll('.js-scroll-down');

    $scrollBtn.forEach(btn => {
        btn.addEventListener('click', function() {
            let $parentSec = this.closest('section'),
                $nextSec = $parentSec.nextElementSibling;

            if ($nextSec) {
                window.scroll({
                    top: $nextSec.offsetTop,
                    behavior: 'smooth'
                });
            }
        });
    });
});